import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataService } from 'src/app/shared/session';
import { SessionInfo } from 'src/app/shared/session/SessionInfo';

@Injectable({
  providedIn: 'root'
})
export class EntidadService {

  constructor(private dataService: DataService, private sessionInfo: SessionInfo) { }

  private listarPorAccesoPath: string = 'entidad/listarPorAcceso';
  private listarPorNivelAccesoPath: string = 'entidad/listarPorNivelAcceso';

  listByAcceso(userName: string, idEmpresa: number, idNivelAcceso: number): any {
    let parameters = new HttpParams();
    parameters = parameters.append("userName", userName);
    parameters = parameters.append("idEmpresa", String(idEmpresa));
    parameters = parameters.append("idNivelAcceso", String(idNivelAcceso));
    this.dataService.set(this.listarPorAccesoPath);
    return this.dataService.execGetJson(parameters);
  }

  listByNivelAcceso(idNivelAcceso: number): any {
    let parameters = new HttpParams();
    parameters = parameters.append("idEmpresa", String(this.sessionInfo.getEmpresaID()));
    parameters = parameters.append("idNivelAcceso", String(idNivelAcceso));
    this.dataService.set(this.listarPorNivelAccesoPath);
    return this.dataService.execGetJson(parameters);
  }
}
